import '../App.css';
import React from 'react';
import { auth } from '../firebase';
import { useState } from 'react';
import { signInAnonymously } from "firebase/auth";
import { updateParticipantData, logStartTest } from '../logging.js';
import { TextField, Flex, Button, Form, Provider, defaultTheme, Text, Heading, Image} from '@adobe/react-spectrum';
import uiButtons from './images/ui-buttons.png';
import noSelection from './images/no-selection.png';
import cursorSelection from './images/cursor-highlight.png';
import selection from './images/selection.png';
import highlight from './images/highlight.png';
import deleteHighlight from './images/delete.png';
import toolbar from './images/toolbar.png';

function ExperimentInstructions({participantId, stage, maxWordCount, callbacks}) {
    function submitForm(e) {
        e.preventDefault();
        if (stage === "highlight"){
            updateParticipantData(participantId, {currentStage: "highlight", highlightStartTime: Date.now()});
            callbacks.setPage("highlight");
        }

        else if (stage === "test"){
            logStartTest(participantId, callbacks);
        }
    }

    return (
        <>          
           <Provider theme={defaultTheme} colorScheme='light'>
                <Flex direction="column" justifyContent={'center'} alignItems={"center"}>             
                    <div id="textToRead" className='documentReader'>
                        <Heading level={1} width="100%" marginBottom="size-100" marginTop="size-0">Instructions</Heading>

                        {stage === "highlight" ?
                        <>
                            <Text>In this experiment, you will be asked to (1) read a short story and (2) complete a reading comprehension test 24 hours later, where you will answer questions about the story. The test will be open-book, and will have 20 multiple choice questions. You will have 5 minutes to complete the test. Make sure you have a stable internet connection.</Text><br/><br/>
                                { maxWordCount === 0 ? null : <Text>While reading the story, you will be asked to highlight parts of the story that you think are important to help you study for the upcoming test. </Text>}
                                { maxWordCount > 0 ? <><Text>However, <b>you will only be allowed to highlight up to  {maxWordCount} words.</b></Text></> : null }
                                { maxWordCount === 0 ? null :
                                <>
                                <br/>
                                <br/>
                                <Heading level={2} width="100%" marginBottom="size-100" marginTop="size-0">How to Highlight</Heading>
                                <Text>This is a simple highlighting tool, so you cannot adjust the colours. All highlights will appear yellow. There is also no "comment" functionality tied to highlights.</Text>
                                
                                <br/><br/>
                                
                                <Text>You can highlight using the Cursor tool, or the Highlighter tool. By default, the Highlighter tool will be selected.</Text><br/><br/>
                                
                                <Flex direction="column" justifyContent={'center'} alignItems={"center"}>
                                    <Image src={uiButtons} width={'30%'} alignItems={"center"} alt=""></Image>
                                </Flex>
                                
                                <br/><br/>


                                <Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">Using the Highlighter Tool</Heading>

                                <Text>Drag your cursor over words you wish to highlight. The text selection will snap to entire words (note that selecting text at the end of a line might select the first word of the next or previous line as well). Highlights will be added automatically on mouse release. </Text>

                                <Flex direction="row" justifyContent={'center'} alignItems={"center"} gap={'size-100'}>
                                    <Image src={noSelection} width={'25%'} alignItems={"center"} alt=""></Image>
                                    <Image src={selection} width={'25%'} alignItems={"center"} alt=""></Image>
                                    <Image src={highlight} width={'25%'} alignItems={"center"} alt=""></Image>
                                </Flex>

                                <br/><br/>

                                <Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">Using the Cursor Tool</Heading>

                                <Text>Drag your cursor over words you wish to highlight. The text selection will snap to entire words (note that selecting text at the end of a line might select the first word of the next or previous line as well). A black highlighter button will appear beside the text selection. Clicking this button will add a new highlight.</Text><br/><br/>
                                
                                <Flex direction="row" justifyContent={'center'} alignItems={"center"} gap={'size-100'}>
                                    <Image src={noSelection} width={'25%'} alignItems={"center"} alt=""></Image>
                                    <Image src={selection} width={'25%'} alignItems={"center"} alt=""></Image>
                                    <Image src={cursorSelection} width={'25%'} alignItems={"center"} alt=""></Image>
                                    <Image src={highlight} width={'25%'} alignItems={"center"} alt=""></Image>
                                </Flex>

                                <br/><br/>

                                <Text>If for some reason your highlights do not appear, try keeping your cursor closer to the text.</Text>

                                <br/><br/>

                                <Heading level={2} width="100%" marginBottom="size-100" marginTop="size-0">How to Delete a Highlight</Heading>


                                <Text>To delete a highlight, click on it, and then click on the black Delete button that appears.</Text>

                                <Flex direction="row" justifyContent={'center'} alignItems={"center"} gap={'size-100'}>
                                    <Image src={highlight} width={'25%'} alignItems={"center"} alt=""></Image>
                                    <Image src={deleteHighlight} width={'25%'} alignItems={"center"} alt=""></Image>
                                    <Image src={noSelection} width={'25%'} alignItems={"center"} alt=""></Image>
                                </Flex>

                                <br/><br/>

                                </>
                                }

                                {maxWordCount > 0 ?
                                <>
                                <Heading level={2} width="100%" marginBottom="size-100" marginTop="size-0">Word Limit</Heading>
                                <Text>At the top, a progress bar will keep track of how many words you have highlighted so far. If you meet or exceed {maxWordCount} words, <b>you will not be allowed to highlight any more words.</b> To regain the ability to highlight, <b>you must delete or edit your existing highlights.</b></Text>
                                <br/><br/>
                                
                                <Flex direction="column" justifyContent={'center'} alignItems={"center"}>
                                    <Image src={toolbar} width={'90%'} alignItems={"center"} alt=""></Image>
                                </Flex>
                                <br/><br/>

                                </>
                                
                                
                                : null}
                            <Text><b>Do not take any notes or screenshots of the passage or its contents.</b> Once you finish, you can press the black Finish Reading button at the bottom right corner of the page. You will then be asked some questions about your experience.</Text><br/><br/>
                            <Text>You may now begin the first part of the experiment by pressing the button below. If you would like to participate in the second part of the experiment (the reading comprehension test) and you found this experiment through a third-party site (e.g., MTurk or Prolific), please accept the second HIT we will post the following day.</Text>
                        </>             
                        
                        : <>

                            <Text>Previously, you read{maxWordCount === 0 ? null : " and highlighted"} a short story in preparation for a reading comprehension test. In this part of the experiment, you will answer 20 multiple choice questions about the story. Make sure you have a stable internet connection.</Text>
                            <br/><br/>
                            <Text>This is an open-book test, so you will have access to the story{maxWordCount === 0 ? null : " and your highlights from last time"} as you answer the questions.</Text>
                            <br/><br/>
                            <Text><b>You will have 5 minutes to answer the questions.</b> After 5 minutes, the test will automatically end, so make sure you can do it in one sitting. If you finish before 5 minutes have passed, you can press the black Finish Test button. You will then be asked some questions about your experience.</Text><br/><br/>
                                       
                            <Text>You may now begin the second part of the experiment by pressing the button below. The top 25% will receive an additional $3 CAD bonus (please note that this may happen after a few days, once all data for this study has been collected).</Text>

                        
                        </>
                        }
                        
                        
                        <Form marginTop="size-200" onSubmit={e => submitForm(e)}>
                            <Button variant='primary' type="submit" style='fill'>Start {stage === "highlight" ? "Experiment" : "Test"}</Button>
                        </Form>
                    </div>
                </Flex>
            </Provider>
        </>
    );
}

export default ExperimentInstructions;